import { Action, Reducer } from 'redux';
import {
  SchedulerUsersState,
  SchedulerUsersTypes,
  SchedulerUsersActionTypes
} from './schedulerUsersTypes';
import { isNullUndefined } from '@/main/services/utils';

export const INITIAL_STATE: SchedulerUsersState = {
  schedulerUsers: {
    data: null,
    errorMessages: null,
    isError: false,
    isLoading: false
  }
};

const schedulerUsersReducer: Reducer<SchedulerUsersState> = (
  state: SchedulerUsersState = INITIAL_STATE,
  action: Action
) => {
  const actionTypes = action as SchedulerUsersActionTypes;
  switch (actionTypes.type) {
    case SchedulerUsersTypes.GET_SCHEDULER_USERS:
      return {
        ...state,
        schedulerUsers: { ...state.schedulerUsers, isLoading: true }
      };
    case SchedulerUsersTypes.SAVE_SCHEDULER_USERS:
      const orderedUsersByName = isNullUndefined(actionTypes.payload.data)
        ? []
        : actionTypes.payload.data.sort((a, b) => {
            const formattedA = a.value.toLowerCase();
            const formattedB = b.value.toLowerCase();

            if (formattedA < formattedB) return -1;
            if (formattedA > formattedB) return 1;
            return 0;
          });

      return {
        ...state,
        schedulerUsers: {
          ...state.schedulerUsers,
          isLoading: false,
          errorMessages: actionTypes.payload.errorMessages,
          isError: actionTypes.payload.isError,
          data: orderedUsersByName
        }
      };
    case SchedulerUsersTypes.RESET_REDUCER_SCHEDULER_USERS:
      return {
        ...state,
        schedulerUsers: INITIAL_STATE.schedulerUsers
      };
    default:
      return state;
  }
};

export default schedulerUsersReducer;

